var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#225378",
    viewBox: "-143 145 512 512"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 112,
    cy: 400,
    r: 220,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113 446c24.8 0 45.1-20.2 45.1-45.1a45.16 45.16 0 0 0-45-45.1c-15 0-28.3 7.4-36.5 18.8-5.3 7.4-8.5 16.5-8.5 26.3A44.94 44.94 0 0 0 113 446m98.4-100.1v-43.4h-5.6l-37.8.1.2 43.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M183 401c0 38.6-31.4 70-70 70s-70-31.4-70-70c0-9.3 1.9-18.2 5.2-26.3H10v104.8C10 493 21 504 34.5 504h157c13.5 0 24.5-11 24.5-24.5V374.7h-38.2c3.4 8.1 5.2 17 5.2 26.3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113 145c-141.4 0-256 114.6-256 256s114.6 256 256 256 256-114.6 256-256-114.6-256-256-256m128 229.7v104.8c0 27.3-22.2 49.5-49.5 49.5h-157C7.2 529-15 506.8-15 479.5V322.4c0-27.3 22.2-49.5 49.5-49.5h157c27.3 0 49.5 22.2 49.5 49.5z"
  })));
};
export default SvgInstagram;